module.exports = __webpack_public_path__ + "img/starperformers-head.b0043420.png";